const _ = require("lodash");
const PageShared = require("./PageShared");
const GradeChapter = require("./GradeChapter");
const LabUtil = require("./LabUtil");
const StringUtil = require("./StringUtil");
const MiscBlockUtil = require("./MiscBlockUtil");
const KnowledgeBase = require("./KnowledgeBase");

// This file contains forPageState that converts a page object to a URL, and
// other forX functions that convert arguments to a URL or page object. To get
// the URL, just call the function normally. Example: URLMake.forChapter(3).
// To get the page state instead, include .state before the call. Example:
// URLMake.state.forChapter(3). (This form can't be used with forPageState.)

// Internally, not including .state wraps the call with forPageState, and
// including it uses the function in its most basic form.

const fromIndexToNumber = function(n) {
	return typeof n === "number" ? n + 1 : n;
};

// Compute the URL for the page state.
const forPageState = function(page) {
	let href;
	if (!page) {
		return null;
	} else if (page.name === "office.main") {
		href = "/";
		if (page.openEmailModal) {
			href = "/mailingList";
		}
	} else if (page.name === "home.postSignin") {
		href = "/post-signin";
	} else if (page.name === "office.termsAndPrivacy") {
		const section = page.section || "privacy";
		href = `/${section}`;
	} else if (page.name === "office.checkout") {
		href = `/checkout/${page.step}`;
	} else if (page.name === "office.redeemSubscription") {
		href = `/redeemSubscription`;
	} else if (page.name === "office.accountSetup") {
		if (page.type === "parent") {
			href = `/${page.requireLoggedIn ? "baParentSetup" : "parentSetup"}/${
				page.isMultiple
			}/${page.email}/${page.code}`;
		} else {
			href = `/${page.requireLoggedIn ? "baAccountSetup" : "accountSetup"}/${
				page.email
			}/${page.code}`;
		}
	} else if (page.name === "office.faq") {
		const section = page.section || "books";
		href = `/faq/${section}`;
		if (page.questionHash) {
			href += `/${page.questionHash}`;
		}
	} else if (page.name === "office.contact") {
		href = "/contact";
		if (page.reason) {
			href += `/${page.reason}`;
		}
	} else if (page.name === "office.about") {
		href = "/about";
	} else if (page.name === "office.chalkboard") {
		href = "/chalkboard";
	} else if (page.name === "office.cmsInfoPages") {
		const cmsPath = PageShared.fixPath(_.get(page, ["cmsPath"], ""));
		href = `/info/${cmsPath}`;
	} else if (page.name === "office.baonline") {
		href = "/online";
	} else if (page.name === "office.enroll") {
		href = "/online/enroll";
		if (page.preselectedOption) {
			href += `-${page.preselectedOption}`;
		}
	} else if (page.name === "office.bookstore") {
		if (page.section === "collections") {
			href = "/books/collections";
		} else {
			href = "/books";
		}
	} else if (page.name === "office.bookLevel") {
		href = "/books/level-" + page.level;
	} else if (page.name === "office.bookLevelScience") {
		href = "/books/science/level-" + page.level;
	} else if (page.name === "office.allbooks") {
		href = "/books/all-titles";
	} else if (page.name === "office.resources") {
		const section = page.section || "printables";
		const planningCategoryHash = _.toLower(page.planningCategoryHash);
		href = `/resources/${section}`;
		if (section === "planning" && planningCategoryHash) {
			href += `/${planningCategoryHash}`;
		}
	} else if (page.name === "office.educators") {
		href = "/educators";
	} else if (page.name === "office.outcomes") {
		href = "/educators/outcomes";
	} else if (page.name === "office.playground") {
		href = "/playground";
	} else if (page.name === "playingcards.redirect") {
		href = "/cards";
	} else if (page.name === "playingcards.main") {
		href = "/playingcards";
		// TODO: Update UTM practice to align with AOPS standards
		if (page.utm_source) {
			href += `?utm_source=${encodeURIComponent(page.utm_source)}`;
		}
	} else if (page.name === "playingcards.answers") {
		href = "/playingcards/answers";
		if (page.utm_source) {
			href += `?utm_source=${encodeURIComponent(page.utm_source)}`;
		}
	} else if (page.name === "puzzles.daily") {
		href = "/puzzles/daily";
	} else if (page.name === "allten.play") {
		href = "/allten";
	} else if (page.name === "office.book") {
		const hashStr = page.hashMask ? page.hashMask : page.bookHash;
		href = `/books/${hashStr}`;
	} else if (page.name === "office.bookScience") {
		href = `/books/science/${page.bookHash.substring(0, 2)}`;
	} else if (page.name === "office.apparel") {
		href = `/apparel/${page.apparelHash}`;
	} else if (page.name === "office.mailinglist") {
		href = `/mailingList/${page.type}`;
		if (page.subType) href += `/${page.subType}`;
		if (page.error) href += `/${page.error}`;
	} else if (page.name === "parent.account") {
		href = `/account`;
		if (page.section) {
			href += `/${page.section}`;
		}
		if (page.extraInfo) {
			href += `/${page.extraInfo}`;
		}
	} else if (page.name === "office.schools") {
		// TODO determine a better URL structure
		href = `/online/schools`;
	} else if (page.name === "parent.subscribe") {
		const userPart = page.changeType === "add" ? "" : `/${page.studentID}`;
		const step = page.step || "subscribe";
		href = `/account/${page.changeType}${userPart}/${step}`;
	} else if (page.name === "parent.main") {
		href = `/parent/students`;
		if (page.scrollStudentID) {
			href += `/s${page.scrollStudentID}`;
		}
	} else if (page.name === "parent.student") {
		const type = _.get(page, "pageData.type", "progress");
		const {grade, chapter, block, studentID, typeID, labBlockID} =
			page.pageData || {};
		href = `/parent/students/${studentID}/${type}`;
		let filters = "";
		if (grade && type === "progress") {
			filters += `/${grade}`;
			if (grade === "lab") {
				if (typeID) {
					filters += `/${typeID}`;
					if (labBlockID) {
						filters += `/${labBlockID}`;
					}
				}
			} else if (chapter) {
				filters += `/${chapter}`;
				if (block) {
					if (_.isInteger(parseInt(block))) {
						const chapterIndex = chapter - 1;
						const blockIndex = block - 1;
						const chapterID = GradeChapter.toChapterID(grade, chapterIndex);
						const blockID = GradeChapter.toBlockID(chapterID, blockIndex);
						filters += `/${blockID}`;
					} else {
						filters += `/${block}`;
					}
				}
			}
			href += filters;
		} else if (type === "activity") {
			if (page.pageData.date) {
				href += "/" + page.pageData.date;
			}
		}
	} else if (page.name === "parent.support") {
		// These will get re-routed to the Help Site
		if (page.topic) {
			href = `/parent/support/${page.section}/${page.topic}`;
		} else {
			href = `/parent/support/${page.section}`;
		}
	} else if (page.name === "parent.studentPrimaryRegistration") {
		href = `/parent/students/setup`;
		if (page.studentID) {
			href += `/${page.studentID}`;
		}
	} else if (page.name === "school.main") {
		href = `/dashboard`;
		const space = page.space || "reports";
		let tab = page.tab || "schools";
		href += `/${space}`;
		const {
			schoolID,
			classID,
			studentID,
			userID,
			grade, // Can be grade number or area (like "lab")
			chapter,
			bookTest,
			block,
			typeID,
			labBlockID,
			date,
			topic,
			rosteringStep,
		} = page.pageData || {};
		const type = _.get(page, "pageData.type", "progress");
		let filters = "";
		if (grade && type === "progress") {
			filters += `/${grade}`;
			if (grade === "lab") {
				if (typeID) {
					filters += `/${typeID}`;
					if (labBlockID) {
						filters += `/${labBlockID}`;
					}
				}
			} else if (bookTest) {
				filters += `/book-test-${bookTest}`;
			} else if (chapter) {
				filters += `/${chapter}`;
				if (block) {
					if (_.isInteger(parseInt(block))) {
						const chapterIndex = chapter - 1;
						const blockIndex = block - 1;
						const chapterID = GradeChapter.toChapterID(grade, chapterIndex);
						const blockID = GradeChapter.toBlockID(chapterID, blockIndex);
						filters += `/${blockID}`;
					} else {
						filters += `/${block}`;
					}
				}
			}
		} else if (type === "activity") {
			filters += `/${date}`;
		}
		if (schoolID) {
			// Can't have schools as a tab if you're within schools.
			if (tab === "schools") tab = "classes";
			href += `/schools/${schoolID}/${tab}`;
		} else if (classID) {
			href += `/classes/${classID}`;
			if (space === "reports") {
				href += `/${type}`;
				href += filters;
			}
		} else if (studentID) {
			href += `/students/${studentID}`;
			if (space === "reports") {
				href += `/${type}`;
				href += filters;
			}
		} else if (userID) {
			href += `/users/${userID}`;
		} else if (space === "support") {
			href += `/${tab}`;
			if (topic) {
				href += `/${topic}`;
			}
		} else {
			href += `/system/${tab}`;
			if (tab === "subscription" && rosteringStep) {
				href += `/${rosteringStep}`;
			}
		}
	} else if (page.name === "school.testList") {
		href = `/dashboard/reports/academy-tests`;
	} else if (page.name === "school.classReports") {
		const {classID, grade, chapter, block, typeID} = page.pageData || {};
		// This URL is not valid if you tried to go there directly (for printing/vanity)
		href = `/class/${classID}`;
		if (grade) href += `/${grade}`;
		if (chapter) href += `/${chapter}`;
		if (block) {
			if (_.isInteger(parseInt(block))) {
				const chapterIndex = chapter - 1;
				const blockIndex = block - 1;
				const chapterID = GradeChapter.toChapterID(grade, chapterIndex);
				const blockID = GradeChapter.toBlockID(chapterID, blockIndex);
				href += `/${blockID}`;
			} else {
				href += `/${block}`;
			}
		}
		if (typeID) href += `/${typeID}`;
	} else if (page.name === "school.classCards") {
		// This URL is not valid if you tried to go there directly (for printing/vanity)
		href = `/classcards/${page.classID}`;
	} else if (page.name === "school.studentProblem") {
		// This URL is not valid if you tried to go there directly (for printing/vanity)
		href = "/student/problem";
	} else if (page.name === "school.profile") {
		href = "/dashboard/profile";
	} else if (page.name === "home.main") {
		href = "/school";
		if (page.demo) {
			href = `/demo${href}`;
		}
	} else if (page.name === "home.onboarding") {
		href = "/onboarding";
	} else if (page.name === "home.login") {
		href = `/school/signin`;
		if (page.domain) {
			href += `/${page.domain}`;
		}
		if (page.opt && page.opt.loginWith) {
			href += `-prefill/${page.opt.loginWith}`;
		}
	} else if (page.name === "home.signout") {
		href = `/signout`;
		if (page.opts && page.opts.requestedURL) {
			href += `?requestedURL=${encodeURIComponent(page.opts.requestedURL)}`;
		}
	} else if (page.name === "trainer.devProblem") {
		href = `/school/classroom/dev/${page.devProblemName}`;
	} else if (page.name === "trainer.chapter") {
		if (page.demo) {
			// TODO(ENABLE_BA_CONTINUOUS_PLAY): Unify demo experience.
			href = `/demo/school/classroom/`;
		} else {
			if (page.bookSectionID && page.gradeNumber) {
				href = `/school/classroom/${page.gradeNumber}/${fromIndexToNumber(
					page.chapterIndex
				)}/book/${page.bookSectionID}`;
			} else if (page.gradeNumber) {
				href = `/school/classroom/${page.gradeNumber}/${fromIndexToNumber(
					page.chapterIndex
				)}`;
			} else {
				href = `/school/classroom/`;
			}
		}
	} else if (page.name === "trainer.problem") {
		if (!page.gradeNumber) {
			if (page.demo) return `/demo/school/classroom/`;
			else return `/school/classroom/`;
		}
		href = `/school/classroom/${page.gradeNumber}/${fromIndexToNumber(
			page.chapterIndex
		)}`;

		if (page.demo) {
			href = `/demo${href}`;
		}
		if (page.blockType === "character") {
			const chapterID = GradeChapter.toChapterID(
				page.gradeNumber,
				page.chapterIndex
			);
			const blockID = GradeChapter.toBlockID(chapterID, page.blockIndex);
			href += `/${blockID}`;
		} else if (page.bookTestHash) {
			const bookHash = page.bookTestHash.substring(
				page.bookTestHash.length - 2
			);
			href = `/school/classroom/book-test/${bookHash}`;
		} else {
			href += `/${page.blockType}`;
		}
		if (page.problemIndex === "summary") {
			href += "/summary";
		} else if (page.problemIndex === "trophy") {
			href += "/trophy";
		} else if (page.problemIndex === "overview") {
			href += "/overview";
		} else if (typeof page.problemIndex === "number") {
			href += `/${fromIndexToNumber(page.problemIndex)}`;
		}
		if (page.setNumber) {
			href += `/set/${page.setNumber}`;
		}
	} else if (page.name === "trainer.history") {
		if (!page.gradeNumber) {
			if (page.demo) return `/demo/school/classroom/`;
			else return `/school/classroom/`;
		}
		href = `/school/classroom/${page.gradeNumber}/${fromIndexToNumber(
			page.chapterIndex
		)}`;
		if (page.demo) {
			href = `/demo${href}`;
		}
		if (page.blockType === "character") {
			const chapterID = GradeChapter.toChapterID(
				page.gradeNumber,
				page.chapterIndex
			);
			const blockID = GradeChapter.toBlockID(chapterID, page.blockIndex);
			href += `/${blockID}`;
		} else {
			href += `/${page.blockType}`;
		}
		href += "/results";
		if (typeof page.problemIndex === "number") {
			href += `/${fromIndexToNumber(page.problemIndex)}`;
		}
	} else if (page.name === "profile.main") {
		href = "/school/profile";
		if (page.demo) {
			href = `/demo${href}`;
		}

		href +=
			!page.currentTab || page.currentTab === "profile"
				? ""
				: "/" + page.currentTab;

		if (page.currentTab === "activity") {
			href += "/" + page.activity.toggleType;

			if (page.activity.day) {
				href += "/" + page.activity.day;
			}
		}
	} else if (page.name === "library.grade") {
		// Videos tab of the collapsed Library+Theater page keeps the /theater
		// URL so top-bar projector links and old theater bookmarks still land
		// on Videos (see URLParser getTheaterContext). Include chapter when
		// known so level/chapter chips stay reflected in the address bar.
		if (page.tab === "videos") {
			if (page.demo) {
				href = `/demo/school/theater/`;
			} else if (page.gradeNumber) {
				href = `/school/theater/${page.gradeNumber}`;
				if (_.isNumber(page.chapterIndex)) {
					href += `/${fromIndexToNumber(page.chapterIndex)}`;
				}
			} else {
				href = `/school/theater/`;
			}
		} else if (page.demo) {
			href = `/demo/school/library`;
		} else {
			href = `/school/library/${page.gradeNumber}`;
		}
	} else if (page.name === "library.chapter") {
		// Even though page has section information, we don't want to show in URL.
		// Since as user scrolls through page, it would either have to change
		// or it would be wrong.
		if (!page.gradeNumber) {
			if (page.demo) return `/demo/school/library/`;
			else return `/school/library/`;
		}
		href = `/school/library/${page.gradeNumber}/${page.chapterIndex + 1}`;
		if (page.demo) {
			href = `/demo${href}`;
		}
	} else if (page.name === "lab.lobby") {
		href = `/school/lab`;
	} else if (page.name === "lab.type") {
		href = `/school/lab`;
		if (page.typeID) {
			const typeName = LabUtil.getTypeNameForURL(page.typeID);
			if (typeName) {
				href += `/${page.typeID}-${typeName}`;
			} else {
				href += `/${page.typeID}`;
			}
		}
	} else if (page.name === "lab.problem") {
		href = `/school/lab`;
		const typeName = LabUtil.getTypeNameForURL(page.typeID);
		if (typeName) {
			href += `/${page.typeID}-${typeName}`;
		} else {
			href += `/${page.typeID}`;
		}

		const blockName = LabUtil.getBlockNameForURL(page.blockID);
		if (blockName) {
			href += `/${page.blockID}-${blockName}`;
		} else {
			href += `/${page.blockID}`;
		}

		if (page.problemIndex === "summary") {
			href += "/summary";
		} else if (typeof page.problemIndex === "number") {
			href += `/${fromIndexToNumber(page.problemIndex)}`;
		}
	} else if (page.name === "beastbuilder.main") {
		href = "/school/beastbuilder";
	} else if (page.name === "theater.chapter") {
		if (page.demo) {
			href = `/demo/school/theater/`;
		} else {
			if (page.gradeNumber) {
				href = `/school/theater/${page.gradeNumber}/${fromIndexToNumber(
					page.chapterIndex
				)}`;
			} else {
				href = `/school/theater/`;
			}
		}
	} else if (page.name === "theater.set") {
		if (!page.gradeNumber) {
			if (page.demo) return `/demo/school/theater/`;
			else return `/school/theater/`;
		}
		href = `/school/theater/${page.gradeNumber}/${fromIndexToNumber(
			page.chapterIndex
		)}/${page.blockID}`;
		if (page.demo) {
			href = `/demo${href}`;
		}
		if (_.isNumber(page.videoIndex)) {
			href += `/${fromIndexToNumber(page.videoIndex)}`;
		}
	} else if (page.name === "tutorial.main") {
		href = "/school/tutorial";
	} else if (page.name === "office.confirmEmail") {
		href = `/confirmEmail/${page.type}`;
		if (page.email) href += `/${page.email}`;
	} else if (page.name === "online.saveWithFriends") {
		href = `/online/save-with-friends`;
	} else if (page.name === "online.gifting") {
		href = `/gift`;
	} else {
		href = null;
	}

	return href;
};

// Other forX functions. These are written as page state returning functions.
// The exports monkeying is done at the end.

/* Trainer places */

const forTutorial = function() {
	return {
		name: "tutorial.main",
	};
};

const forDemo = function(basePage) {
	if (!basePage) return null;
	if (!PageShared.isValidDemoPage(basePage)) {
		return basePage;
	}
	return _.extend({}, basePage, {
		demo: true,
	});
};

const forDemoHome = function() {
	return {
		name: "home.main",
		demo: true,
	};
};

const forDevProblem = function(name) {
	return {
		name: "trainer.devProblem",
		devProblemName: name,
	};
};

const forDevEngineTester = function(params) {
	return {
		name: "trainer.devEngineTester",
		params,
	};
};

const forChapter = function(chapter) {
	const {model} = chapter;
	return forChapterFromModel(model);
};

const forChapterBookFromBlock = function(block) {
	const {model} = block;
	return {
		name: "trainer.chapter",
		gradeNumber: model.gradeNumber,
		chapterIndex: model.chapterIndex,
		showBook: true,
		bookSectionID: model.bookSectionID,
	};
};

const forChapterFromID = function(chapterID) {
	const {gradeNumber, chapterIndex} = GradeChapter.chapterIDToContext(
		chapterID
	);
	return forChapterFromNumbers(gradeNumber, chapterIndex);
};

const forChapterFromNumbers = function(gradeNumber, chapterIndex) {
	return {
		name: "trainer.chapter",
		gradeNumber: gradeNumber,
		chapterIndex: chapterIndex,
	};
};

const forChapterFromBlock = function(block) {
	return forChapter(block);
};

const forChapterFromModel = function(model) {
	return {
		name: "trainer.chapter",
		gradeNumber: model.gradeNumber,
		chapterIndex: model.chapterIndex,
	};
};

const forBlockFromNumbers = function(gradeNumber, chapterIndex, blockIndex) {
	return {
		name: "trainer.problem",
		gradeNumber: gradeNumber,
		chapterIndex: chapterIndex,
		blockIndex: blockIndex,
		blockType: "character",
	};
};

const forBlock = function(block) {
	const {model} = block;
	return {
		name: "trainer.problem",
		gradeNumber: model.gradeNumber,
		chapterIndex: model.chapterIndex,
		blockIndex: model.blockIndex,
		blockType: model.blockType,
	};
};

const forBlockSet = function(block, setNumber) {
	return {
		name: "trainer.problem",
		...block,
		setNumber,
	};
};

const forTestBlockFromMiscBlockName = function(
	miscBlockName,
	errorMessageInfo
) {
	const gradeNumber = parseInt(
		MiscBlockUtil.getBookTestHashFromName(miscBlockName)
	);
	return {
		name: "trainer.problem",
		gradeNumber,
		blockType: "test",
		errorMessageInfo,
		bookTestHash: miscBlockName,
	};
};

const forTestBlockFromChapterID = function(chapterID, errorMessageInfo) {
	const chapterContext = GradeChapter.chapterIDToContext(chapterID);
	const {gradeNumber, chapterIndex} = chapterContext;
	return {
		name: "trainer.problem",
		gradeNumber,
		chapterIndex,
		blockType: "test",
		errorMessageInfo,
	};
};

const forTestBlockFromChapter = function(chapter) {
	const {model} = chapter;
	return {
		name: "trainer.problem",
		gradeNumber: model.gradeNumber,
		chapterIndex: model.chapterIndex,
		blockType: "test",
	};
};

const forResultSource = function(result) {
	const source = result.source;
	const validTypes = ["block", "trophy", "test"];
	if (source && _.includes(validTypes, source.type)) {
		return forChapterFromNumbers(source.gradeNumber, source.chapterIndex);
	} else if (source.type === "lab") {
		return forLabType(source.typeID);
	} else {
		return null;
	}
};

const forTrophyProblem = function(block) {
	const model = (block && block.model) || {};
	return {
		name: "trainer.problem",
		gradeNumber: model.gradeNumber,
		chapterIndex: model.chapterIndex,
		blockIndex: model.blockIndex,
		blockType: model.blockType,
		problemIndex: "trophy",
	};
};

const forBlockHistory = function(context) {
	return {
		name: "trainer.history",
		gradeNumber: context.gradeNumber,
		chapterIndex: context.chapterIndex,
		blockIndex: context.blockIndex,
		blockType: context.blockType,
	};
};

const forBookTest = function(bookHash) {
	return {
		name: "trainer.problem",
		blockType: "test",
		gradeNumber: parseInt(bookHash[0]),
		bookTestHash: "bookTest" + bookHash,
	};
};

const forProblem = function(result, problemIndex, pageType) {
	const source = result.source;
	if (!source) return null;
	if (source.miscBlockName && source.miscBlockName.startsWith("bookTest")) {
		return {
			name: "trainer.problem",
			blockType: "test",
			gradeNumber: source.gradeNumber,
			bookTestHash: source.miscBlockName,
			problemIndex,
		};
	} else if (source.type === "block" || source.type === "demoBlock") {
		return {
			name: pageType || "trainer.problem",
			gradeNumber: source.gradeNumber,
			chapterIndex: source.chapterIndex,
			blockIndex: source.blockIndex,
			blockType: source.blockType,
			problemIndex,
		};
	} else if (source.type === "lab") {
		return {
			name: "lab.problem",
			blockID: source.blockID,
			typeID: source.typeID,
			problemIndex,
		};
	} else {
		return null;
	}
};

const forHistoryProblem = function(result, problemIndex) {
	return forProblem(result, problemIndex, "trainer.history");
};

const forSummary = function(result) {
	return forProblem(result, "summary");
};

const forBlockSummary = function(block) {
	const {model} = block;
	return {
		name: "trainer.problem",
		gradeNumber: model.gradeNumber,
		chapterIndex: model.chapterIndex,
		blockIndex: model.blockIndex,
		blockType: model.blockType,
		problemIndex: "summary",
	};
};

const forOverview = function(result) {
	return forProblem(result, "overview");
};

const forProfileDefault = function(user) {
	return forProfile();
};

const forProfile = function(userID, tab, activeDay, toggleType) {
	return {
		name: "profile.main",
		currentTab: tab,
		activity: {
			day: activeDay,
			toggleType: toggleType || "minutes",
		},
		optionalProfileID: userID,
	};
};

const forHomework = function() {
	return {
		name: "profile.main",
		currentTab: "homework",
	};
};

const forBeastBuilder = function() {
	return {name: "beastbuilder.main"};
};

const forHome = function() {
	return {name: "home.main"};
};

const forHomeError = function(errorMessageInfo) {
	return {name: "home.main", errorMessageInfo};
};

const forHomeOnboarding = function() {
	return {name: "home.onboarding"};
};

const forLibraryFromNumbers = function(
	gradeNumberIn,
	chapterIndexIn,
	sectionIndex,
	pageNumber
) {
	/*needs to verify valid gradeNumber and chapterIndex*/
	const {gradeNumber, chapterIndex} = GradeChapter.getActiveLibraryIndexPairing(
		gradeNumberIn,
		chapterIndexIn
	);
	if (_.isNumber(chapterIndex)) {
		return {
			name: "library.chapter",
			gradeNumber,
			chapterIndex,
			sectionIndex,
			pageNumber,
		};
	} else {
		return {
			name: "library.grade",
			gradeNumber,
		};
	}
};

const forDefaultLibraryGrade = function(user) {
	const lpd = PageShared.getMostRecentPageDataForUser(user);
	return forLibraryFromNumbers(lpd.gradeNumber);
};

const forDemoLibraryGrade = function() {
	return {name: "library.grade", gradeNumber: 0, demo: true};
};

const forTheaterFromNumbers = function(
	gradeNumberIn,
	chapterIndexIn,
	blockID,
	videoIndex
) {
	/*needs to verify valid gradeNumber and chapterIndex*/
	const {gradeNumber, chapterIndex} = GradeChapter.getActiveTheaterIndexPairing(
		gradeNumberIn,
		chapterIndexIn
	);
	if (_.isNumber(blockID)) {
		return {
			name: "theater.set",
			gradeNumber,
			chapterIndex,
			blockID,
			videoIndex,
		};
	} else {
		return {
			name: "theater.chapter",
			gradeNumber,
			chapterIndex,
		};
	}
};

const forDefaultTheaterGrade = function(user) {
	const tpd = PageShared.getMostRecentPageDataForUser(user);
	return forTheaterFromNumbers(tpd.gradeNumber, tpd.chapterIndex);
};

const forDemoTheaterChapter = function() {
	return {name: "theater.chapter", demo: true};
};

// Lab
const forLabType = function(typeID) {
	return {
		name: "lab.type",
		typeID,
	};
};

const forLabLobby = function() {
	return {
		name: "lab.lobby",
	};
};

const forDefaultLabType = function(user) {
	const tpd = PageShared.getMostRecentPageDataForUser(user);
	const defaultTypeID = LabUtil.getActiveTypeIDs()[0];
	return forLabType(tpd.typeID || defaultTypeID);
};

const forLabBlock = function(block, problemIndex) {
	const {model} = block;
	const {blockID, displayName, typeID} = model;
	return {
		name: "lab.problem",
		blockID,
		displayName,
		typeID,
		problemIndex,
	};
};

const forLabBlockSummary = function(block) {
	const {model} = block;
	const {blockID, displayName, typeID} = model;
	return {
		name: "lab.problem",
		blockID,
		displayName,
		typeID,
		problemIndex: "summary",
	};
};

const forLogin = function(domain) {
	return {name: "home.login", domain};
};

// Used with logout endpoint
const forLoginWith = function(loginWith) {
	return {name: "home.login", opt: {loginWith}};
};

// opts: {
//   requestedURL: string
// }
const forSignout = function(opts = {}) {
	return {name: "home.signout", opts};
};

const forDefaultTrainerPage = function(user) {
	// We always want to go to the chapter page.
	return forDefaultChapterPage(user);
};

const forDemoChapter = function() {
	return {
		name: "trainer.chapter",
		gradeNumber: 0,
		chapterIndex: 0,
		demo: true,
	};
};

const forDefaultChapterPage = function(user) {
	const tpd = PageShared.getMostRecentPageDataForUser(user);
	return forChapterFromNumbers(tpd.gradeNumber, tpd.chapterIndex);
};

const forDefaultTeachToOneError = function(errorMessageInfo) {
	const {
		gradeNumber,
		chapterIndex,
		blockIndex,
	} = PageShared.getTeachToOneTrainerPageDefault();
	return _.extend(
		{},
		forBlockFromNumbers(gradeNumber, chapterIndex, blockIndex),
		{errorMessageInfo}
	);
};

/* For Sell pages */

const forOffice = function() {
	return {
		name: "office.main",
	};
};

const forOnlineSchools = function() {
	return {name: "office.schools"};
};

const forPrivacy = function() {
	return {name: "office.termsAndPrivacy", section: "privacy"};
};

const forTerms = function() {
	return {name: "office.termsAndPrivacy", section: "terms"};
};

const forContact = function() {
	return {name: "office.contact"};
};

const forContactReason = function(reason) {
	return {name: "office.contact", reason};
};

const forAbout = function() {
	return {name: "office.about"};
};

const forBAOnline = function() {
	return {name: "office.baonline"};
};

//section is an optional string that can specify what tab of faq
const forFAQ = function(section, questionHash) {
	return {
		name: "office.faq",
		section: section || "books",
		questionHash: questionHash || null,
	};
};

const forCMSInfoPage = function(cmsPath) {
	return {
		name: "office.cmsInfoPages",
		cmsPath: cmsPath || [],
	};
};

const forBookstore = function() {
	return {name: "office.bookstore"};
};

const forBookCollections = function() {
	return {name: "office.bookstore", section: "collections"};
};

const forBook = function(bookHash) {
	return {name: "office.book", bookHash};
};

const forScienceBook = function(bookHash) {
	return {name: "office.bookScience", bookHash};
};

const forBookLevel = function(level) {
	return {name: "office.bookLevel", level};
};
const forScienceBookLevel = function(level) {
	return {name: "office.bookLevelScience", level};
};

const forAllBooks = function() {
	return {name: "office.allbooks"};
};

const forCheckout = function() {
	return {name: "office.checkout", step: "cart"};
};

const forCheckoutStep = function(step) {
	return {name: "office.checkout", step};
};

const forRedeemSubscription = function() {
	return {name: "office.redeemSubscription", step: "account"};
};

const forRedeemSubscriptionStep = function(step) {
	return {name: "office.redeemSubscription", step};
};

const forBAAccountSetup = function(email, code) {
	return {name: "office.accountSetup", requireLoggedIn: true, email, code};
};

const forResources = function(section, planningCategoryHash) {
	return {
		name: "office.resources",
		section,
		planningCategoryHash: _.toLower(planningCategoryHash),
	};
};

const forEducators = function() {
	return {name: "office.educators"};
};

const forOutcomes = function() {
	return {name: "office.outcomes"};
};

const forPlayground = function() {
	return {name: "office.playground"};
};

const forAllTen = function() {
	return {name: "allten.play"};
};

const forDailyPuzzles = function() {
	return {name: "puzzles.daily"};
};

const forEnroll = function() {
	return {name: "office.enroll"};
};

const forApparel = function(apparelHash) {
	return {name: "office.apparel", apparelHash};
};

/* For office teacher and parent pages */
const forParent = function(scrollStudentID = null) {
	if (scrollStudentID) {
		return {name: "parent.main", scrollStudentID};
	}
	return {name: "parent.main"};
};

const forParentSupport = function(section, topic) {
	// All Parent Support pages point to Knowledge Base now
	return (
		KnowledgeBase.getRedirectLink(section, topic) ||
		"https://help.beastacademy.com"
	);
};

const forParentStudent = function(studentID, pageData) {
	return {
		name: "parent.student",
		pageData: _.extend({studentID}, pageData),
	};
};

const forParentStudentPrimaryRegistration = function(studentID = null) {
	return {
		name: "parent.studentPrimaryRegistration",
		...(studentID ? {studentID} : {}),
	};
};

const forAccount = function(section = "subscriptions", extraInfo = null) {
	return {name: "parent.account", section, extraInfo};
};

const forAccountSubscribe = function(
	changeType,
	studentID,
	step = "subscribe"
) {
	return {name: "parent.subscribe", changeType, studentID, step};
};

/* KLUDGE: So far as I can tell, these is an extremely complicated nest of unnecessary
  functions that ultimately simply returns an HTML string.
  I would even endeavor to say that this entire file could be replaced by
  simply hardcoding the URLs into the templates, and be easier to read and less
  duplicated code.
  --kab */
const forTopBarType = function(type, role) {
	let supportLink = forSchoolSupport("play");
	if (role === "parent") {
		supportLink = forParentSupport();
	} else if (role === "teacher") {
		supportLink = forSchoolSupport("getStarted");
	}

	let resourcesLink = forResources("planning");
	if (role === "student") {
		resourcesLink = forPlayground();
	}

	const urlMap = {
		offerings: forBAOnline(),
		books: forBookstore(),
		online: forBAOnline(),
		resources: resourcesLink,
		teacher: forSchool("reports", "schools"),
		parent: forParent(),
		reports: forSchool("reports"),
		accounts: forSchool("accounts"),
		support: supportLink,
		educators: forEducators(),
		// because the top bar needs to go to /online and not /online/enroll, we cannot use forEnroll here.
		enroll: {name: "office.baonline"},
	};
	return urlMap[type];
};

// For Schools

// pageData: {classID, studentID, type = "progress"|"activity"}
const forSchool = function(space, tab, pageData = {}) {
	return {
		name: "school.main",
		space: space || "reports",
		tab: tab || "schools",
		pageData,
	};
};

const forSchoolRostering = function(step) {
	return {
		name: "school.main",
		space: "accounts",
		tab: "subscription",
		pageData: {
			rosteringStep: step,
		},
	};
};

const forStaffProfile = function() {
	return {
		name: "school.profile",
	};
};

const forSchoolAccount = function(schoolID, tab) {
	return {
		name: "school.main",
		space: "accounts",
		tab,
		pageData: {schoolID},
	};
};

const forClassAccount = function(classID, tab) {
	return {
		name: "school.main",
		space: "accounts",
		tab,
		pageData: {classID},
	};
};

const forUserAccount = function(userID) {
	return {
		name: "school.main",
		space: "accounts",
		pageData: {userID},
	};
};

const forStudentReport = function(studentID, pageData = {}) {
	return {
		name: "school.main",
		space: "reports",
		tab: "students",
		pageData: _.extend(
			{studentID},
			_.pick(pageData, [
				"grade",
				"chapter",
				"block",
				"type",
				"date",
				"typeID",
				"labBlockID",
				"bookTest",
			])
		),
	};
};

// Page that shows reports or all students in a class (printing only)
const forAllStudentReports = function(classID, pageData = {}) {
	return {
		name: "school.classReports",
		forPrint: true,
		pageData: _.extend(
			{classID},
			_.pick(pageData, ["grade", "chapter", "block", "typeID", "labBlockID"])
		),
	};
};

const forClassReport = function(classID, pageData = {}) {
	return {
		name: "school.main",
		space: "reports",
		tab: "classes",
		pageData: _.extend(
			{classID},
			_.pick(pageData, [
				"grade",
				"chapter",
				"block",
				"type",
				"date",
				"typeID",
				"labBlockID",
				"bookTest",
			])
		),
	};
};

const forSchoolReport = function(schoolID) {
	return {
		name: "school.main",
		space: "reports",
		tab: "classes",
		pageData: {schoolID},
	};
};

const forSchoolSupport = function(tab, topic) {
	return {
		name: "school.main",
		space: "support",
		tab,
		pageData: {
			topic,
		},
	};
};

const forSaveWithFriends = function() {
	return {name: "online.saveWithFriends"};
};

const forGifting = function() {
	return {name: "online.gifting"};
};

// This is a special case that returns URL directly
// We don't want an actual URL that reflects the page props since this is a printable page.
const forPrintProblem = function(props) {
	const {resultID, blockID, userID, isTrophy, problemIndex, space} = props;
	if (resultID) {
		return `/print/student/problem/${resultID}/${problemIndex}`;
	} else {
		if (space === "lab") {
			return `/print/lab/block/problem/${userID}/${blockID}/${problemIndex}`;
		} else {
			let extra;
			if (isTrophy) {
				extra = "trophy";
			} else {
				extra = problemIndex;
			}
			return `/print/block/problem/${userID}/${blockID}/${extra}`;
		}
	}
};

// This is also a special case because the URL contains coded custom instructions that we don't want shown in the final URL.
// This is for printing student sign in cards for a class
const forClassCards = function(classID, instructions) {
	if (instructions) {
		const instStr = StringUtil.convertToCharCode(instructions);
		return `/dashboard/classcards/${classID}/${instStr}`;
	} else {
		return `/dashboard/classcards/${classID}`;
	}
};

// Direct for functions using a string input
const forDemoFromBaseUrl = function(url) {
	// TODO: try parsing the URL into a page object and running that through forDemo to ensure it
	//       should actually get the demo prefix... ?
	//			 Or actually use the page state and do the conversion to URL as late as possible
	if (!url) return null;
	if (url.substring(0, 5) === "/demo") {
		return url;
	} else {
		return `/demo${url}`;
	}
};

// Utility function to turn page state or URL into a URL
const toURL = function(urlOrPage) {
	if (typeof urlOrPage !== "string") {
		return forPageState(urlOrPage);
	}
	return urlOrPage;
};

// Exports monkeying to get normal and .state functionality described above.

const stateExports = {
	forTutorial,
	forDemo,
	forDemoHome,
	forDevProblem,
	forDevEngineTester,
	forChapter,
	forChapterBookFromBlock,
	forChapterFromNumbers,
	forChapterFromID,
	forChapterFromBlock,
	forChapterFromModel,
	forBlockFromNumbers,
	forBlock,
	forBlockSet,
	forTestBlockFromMiscBlockName,
	forTestBlockFromChapterID,
	forTestBlockFromChapter,
	forResultSource,
	forTrophyProblem,
	forBlockHistory,
	forBookTest,
	forProblem,
	forHistoryProblem,
	forSummary,
	forBlockSummary,
	forOverview,
	forProfile,
	forProfileDefault,
	forHomework,
	forBeastBuilder,
	forHome,
	forHomeError,
	forHomeOnboarding,
	forLogin,
	forLoginWith,
	forSignout,
	forDemoChapter,
	forDemoLibraryGrade,
	forDemoTheaterChapter,
	forDefaultTrainerPage,
	forDefaultChapterPage,
	forDefaultTeachToOneError,
	forOffice,
	forPrivacy,
	forTerms,
	forContact,
	forContactReason,
	forAbout,
	forBAOnline,
	forFAQ,
	forCMSInfoPage,
	forBookstore,
	forBook,
	forScienceBook,
	forBookLevel,
	forScienceBookLevel,
	forBookCollections,
	forAllBooks,
	forCheckout,
	forCheckoutStep,
	forRedeemSubscription,
	forRedeemSubscriptionStep,
	forBAAccountSetup,
	forResources,
	forEducators,
	forOutcomes,
	forPlayground,
	forAllTen,
	forDailyPuzzles,
	forEnroll,
	forApparel,
	forLibraryFromNumbers,
	forDefaultLibraryGrade,
	forTheaterFromNumbers,
	forDefaultTheaterGrade,
	forLabType,
	forLabLobby,
	forDefaultLabType,
	forLabBlock,
	forLabBlockSummary,
	forAccount,
	forAccountSubscribe,
	forParent,
	forParentSupport,
	forParentStudent,
	forParentStudentPrimaryRegistration,
	forTopBarType,
	forSchool,
	forSchoolRostering,
	forStaffProfile,
	forSchoolAccount,
	forClassAccount,
	forUserAccount,
	forStudentReport,
	forAllStudentReports,
	forClassReport,
	forSchoolReport,
	forOnlineSchools,
	forSchoolSupport,
	forSaveWithFriends,
	forGifting,
};

const urlExports = _.mapValues(stateExports, f => (...args) =>
	toURL(f(...args))
);

module.exports = _.extend(
	{
		forPageState,
		forDemoFromBaseUrl,
		toURL,
		state: stateExports,
		forPrintProblem,
		forClassCards,
	},
	urlExports
);
